// 导入组件
import Vue from "vue";
import Router from "vue-router";
// 登录
import login from "@/views/login";
// 首页
import index from "@/views/index";

//首页
import home from "@/views/home/home";

//时间视图
import work from "@/views/work/index";
//时间视图-人员视图
import pleview from "@/views/work/pleview";
//全局视图
import gloview from "@/views/work/gloview";
//人员视图
import peoview from "@/views/work/peoview";

//人员视图详情
import peodetail from "@/views/work/peodetail";

//修改密码
import user from "@/views/account/user";

//个人资料
import role from "@/views/account/role";

//项目设置
import setting from "@/views/setting/setting";

//添加项目
import addproject from "@/views/setting/addproject";

//团队管理
import gmanage from "@/views/setting/gmanage";

//部门管理
import dmanage from "@/views/setting/dmanage";

//权限组
import permission from "@/views/setting/permission";

//我的任务
import myTask from "../views/work/myTask";

//项目-养车
import itemOne from "../views/myproject/itemOne";
//项目-养车
import itemview from "../views/work/itemview";
//项目-联通大数据
import fence from "../views/unicomData/fenceUpload";
import audits from "../views/unicomData/audits";
import unicomLogin from "../views/unicomData/unicomLogin";
import unicomMap from "../views/unicomData/unicomMap";
import viewTable from "../views/unicomData/viewTable";
import map1004 from "../views/unicomData/map1004";
import map1021 from "../views/unicomData/map1021";
import map1022 from "../views/unicomData/map1022";
import map1023 from "../views/unicomData/map1023";
// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [
    {
      path: "/",
      name: "",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/login",
      name: "登录",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/unicomData/fenceUpload",
      name: "围栏上传",
      component: fence,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/unicomData/unicomLogin",
      name: "智慧任务平台",
      component: unicomLogin,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/unicomData/audits",
      name: "围栏审核",
      component: audits,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/unicomData/unicomMap",
      name: "围栏地图",
      component: unicomMap,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/unicomData/viewTable",
      name: "数据表格详情",
      component: viewTable,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/unicomData/map1004",
      name: "1004",
      component: map1004,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/unicomData/map1021",
      name: "1021",
      component: map1021,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/unicomData/map1022",
      name: "1022",
      component: map1022,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/unicomData/map1023",
      name: "1023",
      component: map1023,
      meta: {
        requireAuth: true
      }
    },
    {
      path: "/index",
      component: index,
      children: [
        {
          path: "/work/myTask",
          name: "首页",
          component: myTask,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/work/index",
          name: "时间视图",
          component: work,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/account/user",
          name: "修改密码",
          component: user,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/account/role",
          name: "个人资料",
          component: role,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/setting/setting",
          name: "项目设置",
          component: setting,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/setting/gmanage",
          name: "团队管理",
          component: gmanage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/setting/dmanage",
          name: "部门管理",
          component: dmanage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/setting/permission",
          name: "权限组",
          component: permission,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/work/pleview",
          name: "时间视图-人员视图",
          component: pleview,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/work/gloview",
          name: "全局视图",
          component: gloview,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/work/peoview",
          name: "人员视图",
          component: peoview,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/work/peodetail",
          name: "人员视图详情",
          component: peodetail,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/myproject/itemOne",
          name: "如意养车",
          component: itemOne,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/setting/addproject",
          name: "添加项目",
          component: addproject,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/work/itemview",
          name: "",
          component: itemview,
          meta: {
            requireAuth: true
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js